<template>
    <form class="search-bar" :style="setWidth" @submit.prevent="handleText">
        <label class="search-bar-label">
            <input class="str-search"
                   type="text"
                   v-model="text"
                   :placeholder="placeholder"
            />
            <span v-if="(text.length > 0)" @click="reset" class="reset-icon"></span>
        </label>
        <div class="search-icon" @click="handleText"></div>
    </form>
</template>

<script>
    export default {
        name: "SearchBar",
        data () {
            return {
              text: this.modelValue,
            }
        },

        props: {
            width: {
                type: String,
                required: false,
                default: '300px'
            },
            placeholder: String,
            modelValue: {
              type: String,
              default: '',
            },
        },

        watch: {
          text(newVal) {
            this.$emit('update:modelValue', newVal);
          },
        },

        computed: {
            setWidth () {
                return 'width: ' + this.width;
            }
        },

        methods: {
            handleText () {
                this.$emit('handle', this.text);
            },
            reset() {
                this.text = '';
                this.$emit('update:modelValue', '');
                this.$emit('reset');
            },
        },
    }
</script>

<style scoped>
    .search-bar {
        display: flex;
        flex-direction: row;
    }

    .search-bar-label {
        position: relative;
        flex-grow: 1;
    }

    .str-search {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #DDDDDD;
        border-radius: 5px 0 0 5px;
        border-right: none;
        outline: none;
        padding: 5px;
    }

    .search-icon {
        width: 40px;
        min-width: 40px;
        border-radius: 0 5px 5px 0;
        background-color: #839f22;
        background-image: url("../assets/loupe.svg");
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    }

    .reset-icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        cursor: pointer;
        background: url('../assets/cross.svg') no-repeat center center;
        background-size: contain;
    }
</style>
